import PrivateImage from '../presentation/PrivateImage';
import React, { useEffect, useRef, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import "../../Print.css";
import { logOut } from "../../helpers/logout";
import { Button, Divider, Grid, Toolbar } from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import Popup from "../presentation/Popup";
import TextInput from "../form/input/TextInput";
import DateInput from "../form/input/DateInput";
import { PDFExport } from "@progress/kendo-react-pdf";
import { getPdfExportProxyProps, savePdfWithEmbeddedImages } from "../../helpers/pdfExport";
import { NotificationManager } from "react-notifications";
import withWidth from "@material-ui/core/withWidth";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { convertSize } from "../../helpers/helper";
import { exportSignatureAsSvgBlob } from "../../helpers/signature";

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    toolbarButtons: {
        marginLeft: "auto",
        "& .MuiFormControl-root": {
            margin: theme.spacing(1),
        },
    },
    marginElement: {
        margin: theme.spacing(2),
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    cardMedia: {
        paddingTop: "56.25%", // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
}));

const DocumentsSigningGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);
    let canvas = useRef(null);
    const [fullScreen, setFullScreen] = useState(false);

    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: "",
        ca_address: "",
        ca_zip: "",
        ca_city: "",
        ca_state: "",
        ca_nationality: "",
        ca_email: "",
        ca_phone: "",
        ca_id: "",
        ca_birth: "",
        ca_relationship: "",
        deceased: "",
        d_address: "",
        d_zip: "",
        d_city: "",
        d_state: "",
        d_place_birth: "",
        d_birth: "",
        d_gender: "",
        d_marital_status: "",
        d_death: "",
        d_place_death: "",
        d_id: "",
        d_nationality: "",
        d_education: "",
        d_last_job: "",
        d_wife_husband: "",
        d_wife_husband_id: "",
        date_of_signature_delegation: new Date(),
        planned_pickup_place: "",
        planned_pickup: "",
        town_funeral: "",
        place_funeral: "",
        date_funeral: "",
        coffin_arrival: "",
        coffin_arrival_place: "",
        signatures: {},
        place: {},
        evidence: {},
        other_party_person: "",
        other_party_comp: "",
    });
    const [show, setShow] = useState(false);
    const [date, setDate] = useState(new Date());
    const [success, setSuccess] = useState(false);
    const [otherPartyPerson, setOtherPartyPerson] = useState("");
    const [otherPartyComp, setOtherPartyComp] = useState("");
    const [location, setLocation] = useState("");
    const [checkBoxValues, setCheckBoxValues] = useState({
        items: false,
        urn: false,
        valuables: false,
        documentation: false,
        allow: false,
        remains: false,
    });
    const [nextSign, setNextSign] = useState(null);

    const handleDate = (e) => {
        setDate(e.target.value);
    };

    const handleLocation = (e) => {
        setLocation(e.target.value);
    };

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem("user")).id;

    const handleCheckBoxes = (e) => {
        const { name, value } = e.target;
        if (value) {
            setNextSign(name);
            setShow(true);
        }
        setCheckBoxValues({ ...checkBoxValues, [name]: value });
    };

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
                if (response.data.defined_texts) {
                    setLocation(
                        response.data.defined_texts.default_signature_place
                    );
                }
            },
            () => {}
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                let data = response.data;
                if (!data.evidence) {
                    data.evidence = {};
                }
                if (!data.place) {
                    data.place = {};
                }
                setFuneral(data);
                data.other_party_person &&
                    setOtherPartyPerson(data.other_party_person);
                data.other_party_comp &&
                    setOtherPartyComp(data.other_party_comp);
                setCheckBoxValues({
                    items: !!data.signatures.items_signature,
                    urn: !!data.signatures.urn_signature,
                    valuables: !!data.signatures.valuables_signature,
                    documentation: !!data.signatures.documentation_signature,
                    allow: !!data.signatures.allow_signature,
                    remains: !!data.signatures.remains_signature,
                });
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning(
                        "Potrebné sa znova prihlásiť!",
                        "Upozornenie",
                        5000
                    );
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const singleFileUploadHandler = (file, tag) => {
        const data = new FormData();
        data.append("someimage", file, `${tag}.svg`);
        data.append("signatures_id", funeral.signatures._id);
        data.append("tag", tag);
        data.append(`date_of_${tag}`, new Date(date).toISOString());
        data.append(`location_of_${tag}`, location);
        UserService.signDocument(data)
            .then((response) => {
                if (200 === response.status) {
                    // If file size is larger than expected.
                    if (response.data.error) {
                    } else {
                        let fileName = response.data;
                        setShow(false);
                        if (tag === "remains") {
                            UserService.updateFuneral({
                                ...funeral,
                                other_party_person: otherPartyPerson,
                                other_party_comp: otherPartyComp,
                            });
                            setFuneral({
                                ...funeral,
                                other_party_person: otherPartyPerson,
                                other_party_comp: otherPartyComp,
                                signatures: {
                                    ...funeral.signatures,
                                    [`${tag}_signature`]: fileName.location,
                                    [`location_of_${tag}`]: location,
                                },
                            });
                        } else
                            setFuneral({
                                ...funeral,
                                signatures: {
                                    ...funeral.signatures,
                                    [`${tag}_signature`]: fileName.location,
                                    [`location_of_${tag}`]: location,
                                },
                            });
                    }
                }
            })
            .catch((e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning(
                        "Potrebné sa znova prihlásiť!",
                        "Upozornenie",
                        5000
                    );
                }
                NotificationManager.error(
                    "Nepodarilo sa podpísať dokument!",
                    "Chyba",
                    5000
                );
                setShow(false);
            });
    };

    const handleSignature = async (tag) => {
        const exportSvg = canvas.current?.exportSvg;

        if (exportSvg) {
            try {
                const blob = await exportSignatureAsSvgBlob(canvas);
                singleFileUploadHandler(blob, tag);
            } catch (e) {
                NotificationManager.error(
                    "Nepodarilo sa podpísať dokument!",
                    "Chyba",
                    5000
                );
                setShow(false);
            }
        }
    };

    const handleExport = () => {
        pdfRef.current.render();
        savePdfWithEmbeddedImages(pdfRef, (error) => {
            if (error) {
                NotificationManager.error(
                    "Nepodarilo sa exportovať PDF!",
                    "Chyba",
                    5000
                );
            }
        });
    };

    const handleClear = () => {
        const resetCanvas = canvas.current?.resetCanvas;

        if (resetCanvas) {
            resetCanvas();
        }
    };

    const showSignDocs = () => {
        if (user) {
            const PageWatermark = () =>
                user.logo ? (
                    <div className="gendoc-page-watermark">
                        <PrivateImage src={user.logo} alt="" />
                    </div>
                ) : null;
            return (
                <div className="document-preview-frame" style={{ border: "1px solid" }}>
                    <PDFExport
                        ref={pdfRef}
                        {...getPdfExportProxyProps()}
                        paperSize="A4"
                        scale={0.75}
                        pageTemplate={PageWatermark}
                        fileName={`dokumenty-${funeral.deceased.replace(
                            " ",
                            ""
                        )}`}
                    >
                        <div className="a4-paper gendoc-doc gendoc-doc--flow">
                            <div className="gendoc-body">
                                <header className="gendoc-header">
                                    <div className="gendoc-header__eyebrow">{user.name}</div>
                                    <h1 className="gendoc-title">Dokumenty na podpis</h1>
                                    <div className="gendoc-header__meta">
                                        {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                    </div>
                                </header>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "items", value: !checkBoxValues.items}})}>{checkBoxValues.items ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Prevzaté oblečenie a doklady</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Obstarávateľ pohrebu{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.contracting_authority}
                                            </span>{" "}
                                            potvrdzuje svojím podpisom, že
                                            odovzdal/a oblečenie, doplnky a doklady
                                            a to:{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.picked_items}
                                            </span>
                                        </p>
                                        <p>
                                            Všetko odovzdané oblečenie a doplnky sa
                                            budú nachádzať na zosnulom alebo v rakve
                                            ak nebolo dohodnuté inak.
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures.location_of_items
                                                    ? funeral.signatures
                                                          .location_of_items
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures.date_of_items
                                                    ? new Date(
                                                          funeral.signatures.date_of_items
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.items_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.items_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "valuables", value: !checkBoxValues.valuables}})}>{checkBoxValues.valuables ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Prevzatie cenností</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Obstarávateľ pohrebu{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.contracting_authority}
                                            </span>{" "}
                                            potvrdzuje svojím podpisom prevzatie
                                            cenných predmetov a to:{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.evidence.items}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures
                                                    .location_of_valuables
                                                    ? funeral.signatures
                                                          .location_of_valuables
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures.date_of_valuables
                                                    ? new Date(
                                                          funeral.signatures.date_of_valuables
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.valuables_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.valuables_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "urn", value: !checkBoxValues.urn}})}>{checkBoxValues.urn ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Prevzatie urny</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Obstarávateľ pohrebu{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.contracting_authority}
                                            </span>{" "}
                                            potvrdzuje svojím podpisom prevzatie
                                            urny zosnulej osoby:{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.deceased}, r.č -{" "}
                                                {funeral.d_id}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures.location_of_urn
                                                    ? funeral.signatures.location_of_urn
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures.date_of_urn
                                                    ? new Date(
                                                          funeral.signatures.date_of_urn
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.urn_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.urn_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "documentation", value: !checkBoxValues.documentation}})}>{checkBoxValues.documentation ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Prevzatie kompletnej dokumentácie</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Obstarávateľ pohrebu{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.contracting_authority}
                                            </span>{" "}
                                            potvrdzuje svojím podpisom prevzatie
                                            kompletnej dokumentácie a to Úmrtný
                                            list, List o prehliadke mŕtveho,
                                            Faktúru, Bloček, Žiadosť o príspevok na
                                            pohreb.
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures
                                                    .location_of_documentation
                                                    ? funeral.signatures
                                                          .location_of_documentation
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures
                                                    .date_of_documentation
                                                    ? new Date(
                                                          funeral.signatures.date_of_documentation
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.documentation_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.documentation_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "allow", value: !checkBoxValues.allow}})}>{checkBoxValues.allow ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Povolenie na pochovanie</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Podpísaný/á{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.place.owner}
                                            </span>
                                            , ktorý má v nájme hrobové miesto číslo{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.place.place_number} v{" "}
                                                {funeral.town_funeral}
                                            </span>{" "}
                                            povoľuje jeho otvorenie/výkop, za účelom
                                            pochovania zosnulého{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.deceased}, r.č -{" "}
                                                {funeral.d_id}
                                            </span>
                                            .
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures.location_of_allow
                                                    ? funeral.signatures
                                                          .location_of_allow
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures.date_of_allow
                                                    ? new Date(
                                                          funeral.signatures.date_of_allow
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.allow_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.allow_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gendoc-consent">
                                    <div className="gendoc-consent__head">
                                        <span className="gendoc-consent__check" title="Kliknutím podpíšete" onClick={() => handleCheckBoxes({target: {name: "remains", value: !checkBoxValues.remains}})}>{checkBoxValues.remains ? "✓" : ""}</span>
                                        <span className="gendoc-consent__title">Odovzdanie ľudských pozostatkov</span>
                                    </div>
                                    <div className="gendoc-legal">
                                        <p>
                                            Dole podpísaný{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.other_party_person
                                                    ? funeral.other_party_person
                                                    : otherPartyPerson}
                                            </span>{" "}
                                            za pohrebnú službu{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.other_party_comp
                                                    ? funeral.other_party_comp
                                                    : otherPartyComp}
                                            </span>{" "}
                                            potvrdzuje svojim podpisom, že PREVZAL
                                            dokumentáciu (List o prehliadke mŕtveho
                                            a štatistické hlásenie o úmrtí, Úmrtný
                                            list alebo OP…) a ľudské pozostatky
                                            zosnulého{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.deceased}
                                            </span>
                                            , s rodným číslom{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {funeral.d_id}
                                            </span>
                                            , ktorý zomrel dňa{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {new Date(
                                                    funeral.d_death
                                                ).toShortFormat()}
                                            </span>
                                            .
                                        </p>
                                    </div>
                                    <div className="gendoc-sign gendoc-sign--single">
                                        <div className="gendoc-sign__col gendoc-sign__col--right">
                                            <div className="gendoc-sign__meta">
                                                V{" "}
                                                {funeral.signatures.location_of_remains
                                                    ? funeral.signatures
                                                          .location_of_remains
                                                    : location}{" "}
                                                dňa{" "}
                                                {funeral.signatures.date_of_remains
                                                    ? new Date(
                                                          funeral.signatures.date_of_remains
                                                      ).toShortFormat()
                                                    : date.toShortFormat()}
                                                .
                                            </div>
                                            {funeral.signatures.remains_signature && (
                                                <PrivateImage
                                                    className="gendoc-sign__sig"
                                                    src={funeral.signatures.remains_signature}
                                                    alt="Podpis"
                                                />
                                            )}
                                            <div className="gendoc-sign__line">Podpis</div>
                                        </div>
                                    </div>
                                </section>

                                <div className="gendoc-legal gendoc-legal--fine">
                                    Tento dokument má nadväznosť na splnomocnenie.
                                </div>
                            </div>
                        </div>
                    </PDFExport>
                </div>
            );
        }
        return <></>;
    };

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true);
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={8}
                            md={9}
                            lg={9}
                            item
                            container
                            justifyContent="flex-end"
                        >
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <TextInput
                                    label="Osoba tretej strany"
                                    name={"otherPartyPerson"}
                                    value={otherPartyPerson}
                                    onChange={(e) => {
                                        setOtherPartyPerson(e.target.value);
                                    }}
                                />
                                <TextInput
                                    label="Služba tretej strany"
                                    name={"otherPartyComp"}
                                    value={otherPartyComp}
                                    onChange={(e) => {
                                        setOtherPartyComp(e.target.value);
                                    }}
                                />
                                <TextInput
                                    label="Miesto podpisu"
                                    name={"location"}
                                    value={location}
                                    onChange={handleLocation}
                                />
                                <DateInput
                                    label="Dátum podpisu"
                                    name={"date"}
                                    value={date}
                                    onChange={handleDate}
                                />
                                <ActionButton color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider />
                    <Grid
                        className={classes.marginTop}
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {showSignDocs()}
                    </Grid>
                </Paper>
            </div>
            <Popup
                title={"Podpis"}
                openPopup={show}
                setOpenPopup={setShow}
                maxW="xl"
                actions={
                    <>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                setFullScreen(!fullScreen);
                            }}
                        >
                            {fullScreen ? "Zmenšiť" : "Zväčšiť"}
                        </Button>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleClear}
                        >
                            Vyčistiť
                        </Button>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                handleSignature(nextSign);
                            }}
                        >
                            Uložiť
                        </Button>
                    </>
                }
            >
                <ReactSketchCanvas
                    ref={canvas}
                    strokeWidth={3}
                    strokeColor="blue"
                    style={{
                        border: "0.0625rem solid #9c9c9c",
                        borderRadius: "0.25rem",
                        display: "block",
                        margin: "0 auto",
                        touchAction: "none",
                        width: fullScreen
                            ? convertSize(props.width)
                            : props.width === "xs"
                            ? "min(300px, 100%)"
                            : "min(500px, 100%)",
                        height: fullScreen
                            ? "min(600px, calc(100vh - 220px))"
                            : props.width === "xs"
                            ? "125px"
                            : "300px",
                    }}
                />
            </Popup>
            {success ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                        state: { from: props.location, number: 5 },
                    }}
                />
            ) : (
                <></>
            )}
        </Container>
    );
};
export default withWidth()(DocumentsSigningGenerator);
